import { render, staticRenderFns } from "./PageUser.vue?vue&type=template&id=20941337&scoped=true"
import script from "./PageUser.vue?vue&type=script&lang=js"
export * from "./PageUser.vue?vue&type=script&lang=js"
import style0 from "./PageUser.vue?vue&type=style&index=0&id=20941337&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20941337",
  null
  
)

export default component.exports